<template>
  <v-container class="white-container d-flex flex-column small-container" fluid>
    <loader :loading="loading"></loader>
    <v-container v-if="errorSummary !== null">
      <img
        id="verify-img"
        alt="Verify-logo"
        class="rounded-0 text-center"
        :src="require('@/assets/svg/session-expired.svg')"
      />
      <h3 class="neutral600--text">{{ $t('token-expired') }}</h3>
      <p class="neutral600--text pt-5">{{ $t('token-expired-message') }}</p>
    </v-container>
    <v-container v-if="verified">
      <img
        id="verify-img"
        alt="Verify-logo"
        class="rounded-0 text-center"
        :src="require('@/assets/svg/email-verified.svg')"
      />
      <h3 class="neutral600--text">{{ $t('account-confirmed') }}</h3>
      <p class="neutral600--text pt-5">{{ $t('account-confirmed-message') }}</p>
      <v-row class="justify-center">
        <v-col sm="5" class="mb-6 pb-0 pt-10">
          <v-btn
            color="primary200"
            :disabled="loading"
            data-cy="login"
            large
            block
            @click="login()"
            class="rounded-lg white--text mb-6"
            >{{ $t('log-in') }}
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
    <v-container v-if="provider">
      <img
        id="verify-img"
        alt="Verify-logo"
        class="rounded-0 text-center"
        :src="require('@/assets/svg/provider-email-verified.svg')"
      />
      <h3 class="neutral600--text">{{ $t('provider-confirmed') }}</h3>
      <p class="neutral600--text pt-5">{{ $t('provider-confirmed-message') }}</p>
    </v-container>
    <v-container v-if="hostingRepresentative">
      <img
        id="verify-img"
        alt="Verify-logo"
        class="rounded-0 text-center"
        :src="require('@/assets/svg/provider-email-verified.svg')"
      />
      <h3 class="neutral600--text">{{ $t('provider-confirmed') }}</h3>
      <p class="neutral600--text pt-5">
        When we <span class="text-bold">evaluate</span> your registration, you will be able to
        <span class="text-bold">log in</span> and <br /><span class="text-bold">add</span> your
        hosting institution data.
      </p>
    </v-container>
  </v-container>
</template>

<script>
import util from '@/mixins/util.js';
import Loader from '@/components/shared/helpers/Loader.vue';

export default {
  name: 'VerifyEmail',
  mixins: [util],
  components: {
    Loader,
  },
  data: () => ({
    loading: false,
    responseStatus: null,
    errorSummary: null,
    verified: null,
    provider: null,
    hostingRepresentative: null,
  }),
  mounted() {
    this.submit();
  },
  methods: {
    submit() {
      this.loading = true;
      this.axios
        .post('/api/v1/auth/verify-email?uuid=' + this.$route.query.uuid)
        .then(body => {
          if (body.data.message === 'provider') {
            this.provider = true;
          } else if (body.data.message === 'institution-representative') {
            this.hostingRepresentative = true;
          } else {
            this.verified = true;
          }
        })
        .catch(error => {
          if (error.request && error.response.status === 400) {
            this.errorSummary = this.$i18n.t(error.response.headers.message);
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>
